/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdmissionGridDto
 */
export interface AdmissionGridDto {
    /**
     * 
     * @type {number}
     * @memberof AdmissionGridDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof AdmissionGridDto
     */
    type?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdmissionGridDto
     */
    anneeScolaire?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdmissionGridDto
     */
    resultat?: string | null;
}

/**
 * Check if a given object implements the AdmissionGridDto interface.
 */
export function instanceOfAdmissionGridDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AdmissionGridDtoFromJSON(json: any): AdmissionGridDto {
    return AdmissionGridDtoFromJSONTyped(json, false);
}

export function AdmissionGridDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdmissionGridDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'anneeScolaire': !exists(json, 'anneeScolaire') ? undefined : json['anneeScolaire'],
        'resultat': !exists(json, 'resultat') ? undefined : json['resultat'],
    };
}

export function AdmissionGridDtoToJSON(value?: AdmissionGridDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'type': value.type,
        'anneeScolaire': value.anneeScolaire,
        'resultat': value.resultat,
    };
}

